function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getModuleApi } from '@inface-sdk/common';
import { PushToken } from '../push-tokens';
import { EventManager } from '../common/utils/event-manager.class';
export var WebPush = /*#__PURE__*/function () {
  function WebPush(pushTokenObject) {
    _classCallCheck(this, WebPush);
    if (!(pushTokenObject instanceof PushToken)) {
      console.error('object is not pushtoken in WebPush instance');
    }
    this._managedGIDs = [];
    this._started = false;
    var imModule = getModuleApi('im') || console.error('cannot load im module');
    this._pushToken = pushTokenObject || console.error('cannot load im module') || {};
    this._imModule = imModule.instantMessage || console.error('cannot load instantMessage insterface in module ');
    this._events = new EventManager();
  }
  return _createClass(WebPush, [{
    key: "gids",
    get: function get() {
      return this._managedGIDs;
    }
  }, {
    key: "isStarted",
    get: function get() {
      return this._started;
    }
  }, {
    key: "events",
    get: function get() {
      return this._events;
    }
  }, {
    key: "pushToken",
    get: function get() {
      return this._pushToken;
    },
    set: function set(value) {
      if (value instanceof PushToken) {
        this._pushToken = value;
      }
    }
  }, {
    key: "imModule",
    get: function get() {
      if (!this._imModule) {
        console.error('IM Module has not loaded');
      }
      return this._imModule;
    }
  }, {
    key: "_onReceivedImMessage",
    value: function _onReceivedImMessage(message) {
      this.events.dispatch('im_message', message);
    }
  }, {
    key: "_onReceivedImEvent",
    value: function _onReceivedImEvent(event) {
      this.events.dispatch('im_event', event);
    }
  }, {
    key: "addGID",
    value: function addGID(_ref) {
      var _this = this;
      var gid = _ref.gid,
        webToken = _ref.webToken;
      if (!gid || !webToken) {
        return;
      }
      if (!this.gids.includes(gid) && this._pushToken) {
        this.gids.push(gid);
        var newTokenObject = Object.assign(Object.create(Object.getPrototypeOf(this._pushToken)), this._pushToken);
        newTokenObject._gid = gid;
        newTokenObject.register().then(function () {
          _this.imModule.addGID({
            gid: String(gid),
            webToken: webToken
          });
        }).catch(function (message) {
          console.error('cannot register new token for push service ', message);
        });
      }
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.imModule) {
          if (_this2._pushToken.type === 'ToyPushToken') {
            var env = _this2._pushToken.env || 'live';
            var toyTokenInfo = _this2._pushToken.toJSON();
            _this2.imModule.initialize({
              env: env,
              gid: toyTokenInfo.gid,
              cid: toyTokenInfo.cid,
              accessToken: toyTokenInfo.npToken,
              accessTokenType: toyTokenInfo.npTokenType,
              onMessage: _this2._onReceivedImMessage.bind(_this2),
              onEvent: _this2._onReceivedImEvent.bind(_this2),
              debug: {
                use: inface.auth.env !== 'live',
                level: 3
              }
            }).then(function (success) {
              _this2._started = true;
              if (success.body && success.body.sub_error) {
                _this2.stop();
                reject({
                  message: 'cannot start im service ',
                  status: _this2.imModule.getStatus(),
                  result: success.body.sub_error
                });
              }
              resolve({
                message: 'IM Module started',
                status: _this2.imModule.getStatus(),
                result: success
              });
            }).catch(function (error) {
              console.error('fail', error);
              _this2.stop();
              reject({
                message: 'cannot start im service ',
                status: _this2.imModule.getStatus(),
                result: error
              });
            });
          }
        } else {
          reject({
            message: 'IM module has not loaded'
          });
        }
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3._started = false;
        if (_this3.imModule) {
          _this3.imModule.finalize();
          resolve(_objectSpread({
            message: 'IM Module stoped'
          }, _this3.imModule.getStatus()));
        } else {
          reject({
            message: 'IM module has not loaded'
          });
        }
      });
    }
  }]);
}();
export default WebPush;